<script setup lang="ts">
import { useAuthStore } from '@/shared/stores/AuthStore'
import { captureException } from '@sentry/vue'
import thumbnail from '@/assets/images/thumbnail-app-4.png'

definePage({
  path: '/login',
  name: 'auth.login',
  meta: {
    layout: 'empty',
    allowAnonymous: true,
  },
})

onBeforeMount(async () => {
  if (await auth.isAuthenticated()) {
    router.push({ name: 'companies.overview' })
  }
})

const auth = useAuthStore()
const router = useRouter()
const isAuthenticating = ref<boolean>(false)

const login = async () => {
  isAuthenticating.value = true

  try {
    await auth.login()
    router.push({ name: '/homepage/Homepage' })
  } catch (error) {
    captureException(error)
  } finally {
    isAuthenticating.value = false
  }
}
</script>

<template>
  <main class="h-100dvh flex grow flex-col items-center gap-y-10 bg-[#fafafa] py-5">
    <img
      :src="thumbnail" alt="Logo"
      class="item-container w-100 rounded-lg object-cover shadow-md"
    >

    <section class="item-container w-100">
      <Card>
        <template #content>
          <div class="flex flex-col items-center gap-y-7.5">
            <section class="flex flex-col items-center gap-y-5 text-center">
              <h1>
                Inloggen
              </h1>

              <p class="max-w-lg leading-tight !px-5">
                Log in met je Swipe4Work account om toegang te krijgen tot de admin.
              </p>
            </section>
            <Button
              :disabled="isAuthenticating"
              icon="fa-brands fa-microsoft"
              label="Inloggen met Microsoft"
              @click="login"
            />
          </div>
        </template>
      </Card>
    </section>

    <section class="flex flex-auto flex-col items-center flex-justify-end">
      <small>
        © {{ (new Date()).getFullYear() }} Swipe4Work
      </small>
    </section>
  </main>
</template>

<style scoped>

</style>
